var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0DCA8EA3-98C2-498F-983E-E9F776836FFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L9.35355339,8.64644661 C9.52711974,8.82001296 9.54640489,9.08943736 9.41140884,9.2843055 L9.35355339,9.35355339 L0.853553391,17.8535534 C0.658291245,18.0488155 0.341708755,18.0488155 0.146446609,17.8535534 C-0.0271197425,17.679987 -0.0464048927,17.4105626 0.0885911588,17.2156945 L0.146446609,17.1464466 L8.293,9 L0.146446609,0.853553391 C-0.0271197425,0.679987039 -0.0464048927,0.410562638 0.0885911588,0.215694497 L0.146446609,0.146446609 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-178.9%",
    y: "-72.2%",
    width: "457.9%",
    height: "288.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.32 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00.00.01-Validation:-Document-type",
    transform: "translate(-296.000000, -434.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(24.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells",
    transform: "translate(0.000000, 140.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell",
    transform: "translate(0.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDDFF/-Icons-/-Chevron-Right",
    transform: "translate(272.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(8.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#333333",
    xlinkHref: "#path-1"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_chevron_right.b2a9742587dfe9af0d4db40f2dd0464f.svg";